import { useState } from "react";
import AssignCourseModal from "../modal/AssignCourseModal";
import SliderCourseListing from "./SliderCourseListing";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentView } from "../../redux/assignCourse/actions";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { showOBLPProgessNaming } from "../../utils/AppUtils";
import { useNavigate } from "react-router-dom";

const OnBoardingSingleCard = ({index, data}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userRole = useSelector((state) => state.user.role);

    const [show, setShow] = useState(false);

    return (
        <>
            <div id={""+data.programID}  className={`accordion-item ${index > 0 ? 'mt-4' : 'mt-5'}`} key={`onboard-${index + 1}`}>
                <div className="accordion-header" id="headingOne">
                    <div className="d-flex mb-4 myOnboarding align-items-center justify-content-between">
                        <h3 className="headign mb-0">{data?.programName}</h3>
                        {userRole === "manager" ? (
                            <div className="col-xl-6 col-lg-6 d-flex justify-content-lg-end team-assign-sec">
                                <div className="text-box-rs d-flex">
                                    <div className="img-leftbef">
                                        <img src="/images/TeamBenefit.svg" alt="team" />
                                    </div>
                                    <div className="benefot">
                                        Get your team to <br></br>benefit from this onboarding path
                                    </div>
                                </div>
                                <div className="button-sec">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block setup-button"
                                        onClick={() => {
                                            dispatch(setCurrentView(1));
                                            setShow(true);
                                        }}
                                    >
                                        + Assign
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block setup-button"
                                        onClick={() => {
                                            let parentId = data.programID
                                            let origin = "broker";
                                            navigate("/assigned-users?parentId=" + parentId + "&origin=" + origin + "&parentName=onboardingpath&isMobile=false")
                                        }}
                                    >
                                        View Assigned
                                    </button>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className="mb-4">
                            <div
                                className="onboard-dics"
                                title={data.description}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        data.description
                                }}
                            ></div>
                        </div>
                    <div className="container-pie">
                        <div className="container-chart">
                            <div className="box d-flex align-items-baseline mb-2">
                                <div
                                    className="chart-7"
                                    style={{
                                        width: 150,
                                        height: 150,
                                        position: "relative",
                                    }}
                                >
                                    <CircularProgressbar
                                        value={data.programprogress}
                                        text={`${data.programprogress}%`}
                                        styles={buildStyles({
                                            pathColor:
                                                96 < 100 ? `#6CC869` : "#6CC869", //FF9700=yellow
                                            trailColor: "#EBEBEB",
                                            textSize: "16px",
                                            text: {
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                fill: "#000",
                                                fontFamily: "Inter",
                                            },
                                        })}
                                    />
                                </div>
                                <p className="chart-content">
                                    {showOBLPProgessNaming(data.programprogress)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="responsive-carousel">
                    {data?.courseList && data?.courseList.length > 0 ? (
                        <SliderCourseListing
                            isOnboarding={data.is_onboarding ? true : false}
                            coursesList={data.courseList}
                            setFavoriteCourse={() => { }}
                            closeModal={""}
                            setCloseModal={() => { }}
                            hasDescription={false}
                            pageType="course"
                            showBlankCard={false}
                            path={'/my-onboarding'}
                            id={data.programID}
                            isLP={true}
                        />
                    ) : (
                        <div className="col-md-12">
                            No on boarding course found
                        </div>
                    )}
                </div>
            </div>
            <AssignCourseModal
                show={show}
                parentName={"Onboarding Path"}
                parentId={data.programID}
                setShow={setShow}
                origin={"broker"}
                isMobile={false}
            />
        </>
    )
}

export default OnBoardingSingleCard;